import { render, staticRenderFns } from "./ActComments.vue?vue&type=template&id=23f27a28&scoped=true"
import script from "./ActComments.vue?vue&type=script&lang=js"
export * from "./ActComments.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=23f27a28&prod&scoped=true&lang=css&external"
import style1 from "./ActComments.vue?vue&type=style&index=1&id=23f27a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f27a28",
  null
  
)

export default component.exports